var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdiHeadRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.496 62.9284C127.734 49.7868 99.7347 56.7828 85.395 78.8532L65.3682 87.2574C63.1327 88.3627 62.6015 92.0494 64.9975 93.4327L73.9825 98.6202L63.6075 116.59C59.8033 123.179 62.0819 131.683 68.6709 135.487L74.6609 138.945L64.2859 156.915L106.216 181.124L122.47 152.971C140.65 154.682 158.534 145.839 168.218 129.067C181.705 105.706 173.857 76.4159 150.496 62.9284ZM130.221 127.096L124.904 107.255L105.063 112.571L101.518 99.3433L121.36 94.0268L116.043 74.1853L129.271 70.641L134.588 90.4825L154.429 85.166L157.973 98.3936L138.132 103.71L143.448 123.552L130.221 127.096Z",
    fill: "#E69A8D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiHeadRemove);
export default __webpack_public_path__ + "static/media/mdi_head-remove.93cde4794ab68b0c06e5d676ffc1f82e.svg";
export { ForwardRef as ReactComponent };